import { render, staticRenderFns } from "./ScienceLeft.vue?vue&type=template&id=19ac6c50&scoped=true&"
import script from "./ScienceLeft.vue?vue&type=script&lang=js&"
export * from "./ScienceLeft.vue?vue&type=script&lang=js&"
import style0 from "./ScienceLeft.vue?vue&type=style&index=0&id=19ac6c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac6c50",
  null
  
)

export default component.exports